// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","link-stack":"link-stack-f23","rows":"rows-a8b","plain":"plain-f31","default":"default-f05"};